<template>
  <ModalComponent class="properties-icon-selector" v-bind="$attrs" ref="iconSelectorModal" v-on="$listeners">
    <Card
      variant="prompt"
      :title="$tc('customizeIcon', 1)"
      :subtitle="`${$t('selected')} ${$tc('facility', 1).toLowerCase()}: ${value.label || $t(value.key)}`"
    >
      <Webcomponent
        v-model="valueComp"
        tag="kvass-icon-selector"
        source="https://unpkg.com/@kvass/widgets@latest/dist/icon-selector.js"
      />
      <template #actions>
        <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="close" />
        <ButtonComponent :label="$t('confirm')" theme="primary" :icon="['fas', 'arrow-right']" @click="submit" />
      </template>
    </Card>
  </ModalComponent>
</template>

<script>
const facilityIconsMap = {
  aircondition: 'fan',
  alarm: 'bell-on',
  balancedVentilation: 'wind',
  balcony: 'table-picnic',
  childFriendly: 'child-reaching',
  broadbandConnection: 'wifi',
  sharedLaundry: 'washing-machine',
  garage: 'square-parking',
  lift: 'elevator',
  noNeighbors: 'eye-slash',
  cableTv: 'tv-retro',
  electricCarsCharging: 'charging-station',
  publicWaterAndSewerage: 'droplet',
  parquet: 'chart-waterfall',
  fireplace: 'fireplace',
  view: 'image-landscape',
  janitorservice: 'user-tie-hair',
  hikingArea: 'person-hiking',
  roofTerrace: 'sunglasses',
  boatBerth: 'sailboat',
  fitnessRoom: 'dumbbell',
  alpineResort: 'person-skiing',
  sauna: 'heat',
  driveableRoadToDestination: 'steering-wheel',
  jacuzzi: 'soap',
  sharedReception: 'lamp-floor',
  freezer: 'snowflake',
  golfCourse: 'golf-flag-hole',
  barbecue: 'grill',
  garden: 'house-tree',
  petsAllowed: 'dog',
  nonSmoking: 'ban-smoking',
  indoorSwimmingPool: 'person-swimming',
  cafeteria: 'utensils',
  drivewayGate: 'warehouse',
  loadingDock: 'truck-ramp-couch',
  universalDesign: 'circle-heart',
  quiet: 'bench-tree',
  central: 'map-pin',
  sunShading: 'sun-dust',
  swimmingOpportunity: 'mask-snorkel',
  fishingOpportunity: 'fish',
  electricityInstalled: 'bolt-lightning',
  waterInstalled: 'faucet-drip',
  shoreline: 'umbrella-beach',
  sportsStorageRoom: 'box-archive',
  expansionPossibilities: 'arrows-maximize',
  walkInCloset: 'booth-curtain',
}
import Card from '@/components/Card-v2'
import { ModalComponent } from 'vue-elder-modal'
import Webcomponent from '@kvass/custom-fields/src/Fields/Webcomponent'

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      internalValue: '',
    }
  },
  computed: {
    defaultIcon() {
      return `fa-pro-solid:${facilityIconsMap[this.value.key] || 'plus'}`
    },
    valueComp: {
      get() {
        return this.internalValue || this.value.icon || this.defaultIcon
      },
      set(val) {
        this.internalValue = val
      },
    },
  },
  methods: {
    submit() {
      if (this.internalValue !== this.defaultIcon) {
        this.$emit('update', this.internalValue)
      }
      this.close()
    },

    close() {
      if (!this.$refs.iconSelectorModal) return
      this.internalValue = ''
      return this.$refs.iconSelectorModal.close()
    },
  },

  components: {
    ModalComponent,
    Card,
    Webcomponent,
  },
}
</script>

<style lang="scss">
.properties-icon-selector {
  .card-v2 {
    min-width: 500px;
    &__content {
      display: flex;
      gap: 2.5rem;
      flex-direction: column;
    }
  }
}
</style>
